import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { serviceInfoDemoData } from '../../../../data/ServiceDemoData';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { handleGetServiceInfoOpe } from './ServiceInfoOperation';

const ServiceInfoContext = createContext();

export const useServiceInfo = () => useContext(ServiceInfoContext);

function ServiceInfoProvider({ serviceId, children }) {
    const [serviceInfoData, setServiceInfoData] = useState(serviceInfoDemoData);
    const [reloadKey, setReloadKey] = useState(0);
    const [showModal, setShowModal] = useState({ type: '', data: null });
    const { setMessage } = useTemplate();

    // Load service info data
    useEffect(() => {
        setServiceInfoData(serviceInfoDemoData);
        handleGetServiceInfoOpe(serviceId)
            .then(({ data }) => {
                setServiceInfoData(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
                setServiceInfoData({});
            });
    }, [serviceId, setMessage, reloadKey]);

    const value = useMemo(() => {
        // Reload key is used to reload the data
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        // Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };

        // Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };

        return {
            serviceInfoData,
            setServiceInfoData,
            reloadKey,
            setReloadKey,
            handleReload,
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data
        };
    }, [serviceInfoData, reloadKey, showModal?.type, showModal?.data]);

    return <ServiceInfoContext.Provider value={value}>{children}</ServiceInfoContext.Provider>;
}

export default ServiceInfoProvider;
